"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedSampoLayout = exports.SampoLayout = void 0;
const react_1 = __importStar(require("react"));
const react_helmet_1 = require("react-helmet");
const react_redux_1 = require("react-redux");
const spa_core_1 = require("@episerver/spa-core");
const foundation_settings_1 = require("@episerver/foundation-settings");
const Placeholder_1 = __importDefault(require("../Placeholder"));
const Navigation_1 = __importDefault(require("./Navigation"));
const Footer_1 = __importDefault(require("./Footer"));
const CampaignLayer_1 = __importDefault(require("../Block/CampaignLayer"));
const LoadingSpinner_1 = __importDefault(require("./LoadingSpinner"));
const SampoLayout = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const settingsService = (0, foundation_settings_1.useSettings)();
    const ctx = (0, spa_core_1.useEpiserver)();
    const [layoutSettings, setLayoutSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('LayoutSettings'));
    const [labelSettings, setLabelSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('LabelSettings'));
    const language = props.currentLanguage;
    const [oneTrustLoaded, setOneTrustLoaded] = (0, react_1.useState)(false);
    const [contentHeight, setContentHeight] = (0, react_1.useState)('100vh');
    const [onetrustActiveGroups, setOnetrustActiveGroups] = (0, react_1.useState)('');
    const [readyForCampaignLayer, setReadyForCampaignLayer] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        var _a;
        let isCancelled = false;
        if (language != undefined && ((_a = layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.language) === null || _a === void 0 ? void 0 : _a.name) !== language) {
            Promise.allSettled([
                settingsService.getContainer('LayoutSettings'),
                settingsService.getContainer('LabelSettings'),
            ]).then((results) => {
                if (!isCancelled) {
                    results[0].status === 'fulfilled' && setLayoutSettings(results[0].value);
                    results[1].status === 'fulfilled' && setLabelSettings(results[1].value);
                    setReadyForCampaignLayer(true);
                }
            });
        }
        return () => { isCancelled = true; };
    }, [language]);
    const isOneTrust = () => {
        try {
            // @ts-ignore
            const isactive = OnetrustActiveGroups !== undefined;
            if (!isactive)
                return false;
            // @ts-ignore
            setOnetrustActiveGroups(OnetrustActiveGroups);
            return true;
        }
        catch (_a) {
            return false;
        }
    };
    const updateOneTrustGroups = () => {
        try {
            // @ts-ignore
            const groups = OnetrustActiveGroups;
            if (props.dispatch)
                props.dispatch({ type: 'ApplicationStates/SetOnetrustchange', onetrustchange: groups });
            setOnetrustActiveGroups(groups);
            document.querySelector('html').style.overflow = '';
            document.querySelector('body').style.overflow = '';
        }
        catch (_a) { }
    };
    const setOneTrustListeners = (remove) => {
        const acceptbtn = document.getElementById('onetrust-accept-btn-handler');
        const removebtn = document.getElementById('onetrust-reject-all-handler');
        if (!remove) {
            if (acceptbtn)
                acceptbtn.addEventListener('click', updateOneTrustGroups);
            if (removebtn)
                acceptbtn.addEventListener('click', updateOneTrustGroups);
            document.querySelectorAll('.ot-btn-container button').forEach(e => e.addEventListener('click', updateOneTrustGroups));
            document.querySelectorAll('#close-pc-btn-handler').forEach(e => e.addEventListener('click', updateOneTrustGroups));
        }
        else {
            document.querySelectorAll('.ot-btn-container button').forEach(e => e.removeEventListener('click', updateOneTrustGroups));
            document.querySelectorAll('#close-pc-btn-handler').forEach(e => e.removeEventListener('click', updateOneTrustGroups));
            if (acceptbtn)
                acceptbtn.removeEventListener('click', updateOneTrustGroups);
            if (removebtn)
                acceptbtn.removeEventListener('click', updateOneTrustGroups);
        }
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (!ctx.isInEditMode()) {
            const onetrustInterval = setInterval(() => {
                if (isOneTrust()) {
                    clearInterval(onetrustInterval);
                    setOneTrustLoaded(true);
                }
            }, 300);
            const onetrustListenerInterval = setInterval(() => {
                if (isOneTrust() && document.querySelectorAll('.ot-btn-container').length > 0) {
                    clearInterval(onetrustListenerInterval);
                    setOneTrustListeners(false);
                }
            }, 300);
            setTimeout(() => {
                clearInterval(onetrustInterval);
                clearInterval(onetrustListenerInterval);
            }, 10000);
            (_a = document.querySelector('#contentRow')) === null || _a === void 0 ? void 0 : _a.focus();
        }
        return () => {
            if (!ctx.isInEditMode()) {
                setOneTrustListeners(true);
            }
        };
    }, []);
    const setContentHeightHandler = (height) => {
        setContentHeight(height);
    };
    const onClickSkipButton = () => {
        const main = document.querySelector('main');
        if (main)
            main.focus();
    };
    if (!layoutSettings || !labelSettings) {
        return react_1.default.createElement("div", { className: "sampo-layout" },
            react_1.default.createElement(react_helmet_1.Helmet, null,
                react_1.default.createElement("html", { lang: props.currentLanguage }),
                react_1.default.createElement("title", null, "Sampo.com"),
                react_1.default.createElement("link", { rel: "shortcut icon", href: "/spaview/app.html.spa/favicon.ico", type: "image/x-icon" })),
            react_1.default.createElement(Placeholder_1.default, { style: { width: '100vw', height: '253px' } }, "Header"),
            react_1.default.createElement(LoadingSpinner_1.default, null),
            react_1.default.createElement(Placeholder_1.default, { style: { width: '100vw', height: '301px' } }, "Footer"));
    }
    const siteLogo = ((_a = layoutSettings.siteLogo) === null || _a === void 0 ? void 0 : _a.value) ? layoutSettings.siteLogo.value : layoutSettings.siteLogo;
    const showCampaignLayer = typeof ((_b = layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.showCampaignLayer) === null || _b === void 0 ? void 0 : _b.value) === 'boolean' ? (_c = layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.showCampaignLayer) === null || _c === void 0 ? void 0 : _c.value : layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.showCampaignLayer;
    const hasOnetrustValues = !ctx.isInEditMode() && !ctx.isServerSideRendering() && ((_d = layoutSettings.onetrustScriptSource) === null || _d === void 0 ? void 0 : _d.value) && ((_e = layoutSettings.onetrustDataDomainId) === null || _e === void 0 ? void 0 : _e.value);
    return react_1.default.createElement("div", { style: { minHeight: contentHeight, maxWidth: '1920px', background: '#fff', margin: 'auto' } },
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("html", { lang: props.currentLanguage }),
            react_1.default.createElement("title", null, "Sampo.com"),
            react_1.default.createElement("link", { rel: "shortcut icon", href: "/spaview/app.html.spa/favicon.ico", type: "image/x-icon" }),
            hasOnetrustValues &&
                react_1.default.createElement("link", { rel: "preload", href: layoutSettings.onetrustScriptSource.value, as: "script" }),
            hasOnetrustValues &&
                react_1.default.createElement("script", { async: true, src: layoutSettings.onetrustScriptSource.value, type: "text/javascript", charSet: "UTF-8", "data-domain-script": layoutSettings.onetrustDataDomainId.value, "data-document-language": "true" }),
            // @ts-ignore
            hasOnetrustValues && oneTrustLoaded > 0 && onetrustActiveGroups.indexOf('C0002') !== -1 &&
                react_1.default.createElement("link", { rel: "preload", href: "https://siteimproveanalytics.com/js/siteanalyze_6049239.js", as: "script" }),
            // @ts-ignore
            hasOnetrustValues && oneTrustLoaded > 0 && onetrustActiveGroups.indexOf('C0002') !== -1 &&
                react_1.default.createElement("script", { async: true, src: "https://siteimproveanalytics.com/js/siteanalyze_6049239.js" }),
            // @ts-ignore
            hasOnetrustValues && ((_f = layoutSettings.trackingScripts) === null || _f === void 0 ? void 0 : _f.value) && oneTrustLoaded > 0 && onetrustActiveGroups.indexOf('C0004') !== -1 &&
                react_1.default.createElement("script", null, layoutSettings.trackingScripts.value),
            // @ts-ignore
            hasOnetrustValues && ((_g = layoutSettings.trackingNoScripts) === null || _g === void 0 ? void 0 : _g.value) && oneTrustLoaded > 0 && onetrustActiveGroups.indexOf('C0004') !== -1 &&
                react_1.default.createElement("noscript", null, `${layoutSettings.trackingNoScripts.value}`)),
        react_1.default.createElement("div", { id: 'contentRow', className: 'row g-0', style: { minHeight: contentHeight }, tabIndex: -1 },
            ((_h = labelSettings.skipToContentLinkText) === null || _h === void 0 ? void 0 : _h.value) &&
                react_1.default.createElement("div", { className: 'skip-button-container position-relative' },
                    react_1.default.createElement("a", { href: '#main', className: 'btn btn-sampo-outline-primary', onClick: onClickSkipButton }, labelSettings.skipToContentLinkText.value)),
            react_1.default.createElement(Navigation_1.default, { setContentHeight: setContentHeightHandler, lang: props.currentLanguage }),
            react_1.default.createElement("div", { id: "contentContainer", className: 'd-flex flex-column position-relative col', style: { minHeight: '100vh', minWidth: '320px', visibility: props.navOpen ? 'hidden' : 'visible' } },
                react_1.default.createElement("div", { style: { display: 'none' }, className: 'print-logo' },
                    react_1.default.createElement(spa_core_1.Components.EpiserverContent, { contentLink: siteLogo, expandedValue: siteLogo.expanded })),
                props.children,
                react_1.default.createElement(Footer_1.default, { settings: layoutSettings }),
                showCampaignLayer && readyForCampaignLayer &&
                    react_1.default.createElement(CampaignLayer_1.default, { settings: layoutSettings, labels: labelSettings }))));
};
exports.SampoLayout = SampoLayout;
exports.ConnectedSampoLayout = (0, react_redux_1.connect)((state, ownProps) => {
    const propsFromState = state.OptiContentCloud || {};
    const propsFromAppState = state.ApplicationStates || {};
    return Object.assign(Object.assign(Object.assign({}, ownProps), propsFromState), propsFromAppState);
})(exports.SampoLayout);
exports.default = exports.ConnectedSampoLayout;
